export const SET_BANNERS = "SET_BANNERS";
export const SET_HOME_CATEGORIES = 'SET_HOME_CATEGORIES'
export const SET_HOME_MERCHANTS = 'SET_HOME_MERCHANTS'
export const SET_HOME_POPULAR_CATEGORIES = 'SET_HOME_POPULAR_CATEGORIES'
export const SET_HOME_PREMIUM_PARTNERS = 'SET_HOME_PREMIUM_PARTNERS'
